module.exports = __webpack_public_path__ + "static/media/judge-gima.261c4401.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/judge-gima.png
// module id = 571
// module chunks = 0